

export const treatRequestToken = (session: string, user: number, action: string) => {
    return {
        session : session,
        user: user,
        action: action
    }
}